import { CommonAction } from '../../../login/redux/types';
import ReferralsTypes, { ReferralState } from './types';

const referralsInitialState: ReferralState = {
    referrals: undefined,
    loading: false,
};

const ReferralReducer = (state = referralsInitialState, action: CommonAction): ReferralState => {
    switch (action.type) {
        case ReferralsTypes.GET_REFERRALS_REQ:
            return {
                ...state,
                referrals:undefined,
                loading: true,
            };
        case ReferralsTypes.SET_REFERRALS:
            return {
                ...state,
                referrals: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

export default ReferralReducer;
